import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=4e678a99&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e678a99",
  null
  
)

export default component.exports